export default __webpack_public_path__ + "static/media/vanilla.6ad67cd8.svg";